__turbopack_context__.v({
  "accordion": "Vw5gBG_accordion",
  "activeThumb": "Vw5gBG_activeThumb",
  "adminActions": "Vw5gBG_adminActions",
  "badgeOffer": "Vw5gBG_badgeOffer",
  "category": "Vw5gBG_category",
  "container": "Vw5gBG_container",
  "ctaButtons": "Vw5gBG_ctaButtons",
  "currentPrice": "Vw5gBG_currentPrice",
  "dot": "Vw5gBG_dot",
  "error": "Vw5gBG_error",
  "gallery": "Vw5gBG_gallery",
  "header": "Vw5gBG_header",
  "heading": "Vw5gBG_heading",
  "iconButton": "Vw5gBG_iconButton",
  "infoSection": "Vw5gBG_infoSection",
  "mainImage": "Vw5gBG_mainImage",
  "metaRow": "Vw5gBG_metaRow",
  "moreSimiler": "Vw5gBG_moreSimiler",
  "navLeft": "Vw5gBG_navLeft",
  "navRight": "Vw5gBG_navRight",
  "oldPrice": "Vw5gBG_oldPrice",
  "priceRow": "Vw5gBG_priceRow",
  "productDetail": "Vw5gBG_productDetail",
  "purchasePanel": "Vw5gBG_purchasePanel",
  "quantityControl": "Vw5gBG_quantityControl",
  "ratingRow": "Vw5gBG_ratingRow",
  "reviewCount": "Vw5gBG_reviewCount",
  "series": "Vw5gBG_series",
  "starFilled": "Vw5gBG_starFilled",
  "starHalf": "Vw5gBG_starHalf",
  "stars": "Vw5gBG_stars",
  "thumb": "Vw5gBG_thumb",
  "thumbs": "Vw5gBG_thumbs",
  "uspItem": "Vw5gBG_uspItem",
  "uspRow": "Vw5gBG_uspRow",
  "wishActive": "Vw5gBG_wishActive",
});
